import clientDialogReducer from './clientDialogReducer';

export default clientDialogReducer;